import { AlertCircle, CheckCircle2, Info, X } from "lucide-react";

import { useToasts, type ToastKind } from "../stores/toastStore";

const KIND_ICON: Record<ToastKind, typeof Info> = {
  success: CheckCircle2,
  error: AlertCircle,
  info: Info,
};

const KIND_COLOR: Record<ToastKind, string> = {
  success: "text-success",
  error: "text-danger",
  info: "text-accent",
};

export function ToastHost() {
  const toasts = useToasts((s) => s.toasts);
  const dismiss = useToasts((s) => s.dismiss);
  if (toasts.length === 0) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-[200] flex flex-col gap-2"
      aria-live="polite"
      role="status"
    >
      {toasts.map((t) => {
        const Icon = KIND_ICON[t.kind];
        return (
          <div
            key={t.id}
            className="flex items-center gap-2.5 min-w-56 max-w-96 px-3.5 py-2.5 bg-bg-1 border border-border rounded-lg shadow-(--shadow-2) animate-[hbc-slideup_0.18s_cubic-bezier(0.2,0.7,0.2,1)]"
          >
            <Icon size={15} className={`shrink-0 ${KIND_COLOR[t.kind]}`} />
            <div className="flex-1 text-[12.5px] text-text-dim">{t.message}</div>
            <button
              className="grid w-5.5 h-5.5 shrink-0 place-items-center rounded-md text-text-muted hover:bg-bg-hover hover:text-text"
              onClick={() => dismiss(t.id)}
              aria-label="Dismiss notification"
            >
              <X size={12} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
